import React from "react";
import { Icon } from "@qgiv/core-react";
import "./TeamFullMessage.scss";

const TeamFullMessage = () => (
    <div className="team-full-message">
        <div className="team-full-message__content -text--center">
            <p>
                <strong>
                    <Icon type="FontAwesome" glyph="exclamation-circle-solid" />{" "}
                    Team Full
                </strong>
            </p>
        </div>
    </div>
);

export default TeamFullMessage;
